export default class PartValidate {
	constructor(public readonly partId: string, public readonly typeId: string | null, public readonly quantity: number) {
	}
}